const crypto = require("crypto-js")
export default function(str) {
  let signature_key = '6d709ef0f5f1761136116ebd194073d0'
  str = crypto.MD5(str).toString()
  return crypto.HmacSHA256(str, signature_key).toString()
}
